export const EXTERNAL_LINKS = {
  TERMS_OF_USE:
    'https://caeitcacestgp1v2b2c.blob.core.windows.net/termsnconditions/terms.html',
  PRIVACY_POLICY: 'https://www.cae.com/privacy-policy',
} as const;
